import { render, staticRenderFns } from "./WishList_Mobile.vue?vue&type=template&id=f977aec0&"
import script from "./WishList_Mobile.vue?vue&type=script&lang=js&"
export * from "./WishList_Mobile.vue?vue&type=script&lang=js&"
import style0 from "./WishList_Mobile.vue?vue&type=style&index=0&id=f977aec0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports